import { Injectable } from '@angular/core';
import { AuthHttp } from '@http';
import { Config } from '@config';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class VerificationService {
    constructor(
        private http : AuthHttp,
        private config : Config
    ){}

    public verificate(code : string){
        return lastValueFrom(this.http
            .putJSON(this.config.services.accounts.verification, { verificationcode : code }, null, true)
        );
    }
}